import type { SxProps, Theme } from '@mui/material/styles';

export const contentTitleWrapSx = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  alignSelf: 'stretch',
  height: '72px',
  margin: '0px',
  paddingTop: '14px',
  paddingBottom: '14px',
  paddingX: {
    xs: '1.5rem',
    sm: '1.5rem',
    md: '1.5rem',
    lg: '3rem',
  },
} satisfies SxProps<Theme>;

export const contentTitleSx = {
  color: 'rgba(0, 0, 0, 0.87)',
  fontFeatureSettings: '"liga" off, "clig" off',
  fontFamily: 'var(--fontFamily, "Helvetica Neue")',
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '22px',
  letterSpacing: '0.25px',
} satisfies SxProps<Theme>;
